var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"cursor-pointer",attrs:{"src":require("../../../../assets/BorrowReturn/detail.svg"),"alt":""},on:{"click":_vm.onIconClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }